export const step4 = {
  mandatory: 'Campo de preenchimento obrigatório',
  licenseNumber: 'N.º de Licença Camararia',
  chipNumber: 'N.º de Chip',
  gender: 'Sexo',
  validationLabel: 'Dados do animal de nome %{name} em falta: ',
  chosenPack: 'PACK ESCOLHIDO',
  table: {
    title: 'Lista de Animais Seguros',
  },
  insuredDataAnimal: 'Dados do Animal Seguro',
  male: 'Macho',
  female: 'Fêmea',
  animalLicenseNumberError:
    'Por favor introduza um valor válido para este campo',
  characterLimit: 'Limite máximo de 15 de caracteres',
  genderAnimal: 'Sexo, ',
  toolTipMandatoryField:
    'É necessário preencher %{hasGender}N.º de Licença Camararia ou Nº de Chip do animal',
  mandatoryField:
    'É necessário preencher N.º de Licença Camararia ou Nº de Chip do animal',
}
